// src/config.js
const AppConfig = {
    title: "زیکری بەیانیان",
    paragraph: "رەحمەت لەوەی بڵاوی دەکاتەوە",
    img: "https://i.postimg.cc/Y98F9gF0/83fe5d77-cc5b-4657-b144-0ab2c39083d0.jpg",
    url: "zikr",
    id: "06090726"
};

export default AppConfig;